<template>
  <v-container fluid>
    <v-card>
      <v-toolbar style="background:#F5F5F5" dense>
        <v-toolbar-title style="color:#01579B;font-weight:bold" dark dense>Liste des cartes actuellement connectées
        </v-toolbar-title
        >
      </v-toolbar>
      <v-card-title>
        <v-btn large
        >
          <download-csv :data="cards" name="cards.csv">
            <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
            Télécharger CSV
          </download-csv>
        </v-btn
        >
        <v-spacer></v-spacer>
        <v-text-field :id="dynamicID()"
                      v-model="search"
                      append-icon="search"
                      label="Rechercher..."
                      single-line
                      hide-details
        ></v-text-field>
      </v-card-title>
      <v-col sm="12" class="text-center">
        <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            top
            color="#01579B"
        ></v-progress-linear>
      </v-col>
      <v-data-table
          :headers="headers"
          :items="cards"
          :search="search"
          :items-per-page="15"
          class="elevation-1"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          show-expand
          no-results-text="Aucun résultat"
          no-data-text="Aucun résultat"
          :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus'
            }"
      >
        <template v-slot:[`item.errorMessage`]="{ item }">
          <v-chip outlined :color="getColor(item.errorMessage)" dark>{{
              item.errorMessage
            }}
          </v-chip>
        </template>
        <template v-slot:[`expanded-item`]="{ headers, item }">
          <td :colspan="headers.length">
            <vue-json-pretty :data="item"></vue-json-pretty>
          </td>
        </template>
        <template v-slot:[`item.createdDate`]="{ item }">
          {{ item.createdDate | formatDate }}
        </template>
        <template v-slot:[`item.revisedDate`]="{ item }">
          {{ item.revisedDate | formatDate }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import apiClient from "../../config/api.js";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  data() {
    return {
      isMobile: isMobileDevice(),
      search: "",
      headers: [
        {text: "ID", value: "id", sortable: false},
        {text: "Date création", value: "createdDate"},
        {text: "Empreinte digitale", value: "fingerprint", sortable: false},
        {
          text: "Numéro carte",
          align: "left",
          sortable: false,
          value: "cardNumber",
        },
        {text: "Message d'erreur", value: "errorMessage", sortable: false},
        {text: "Matricule agent", value: "userId"},
        {text: "Date de révision", value: "revisedDate"},
      ],
      cards: [],
      loading: true,
      expanded: [],
      singleExpand: true,
    };
  },
  created() {
    apiClient
        .get(`${this.$store.getters.user.baseUrl}/admin/cards`)
        .then((data) => {
          setTimeout(() => (this.loading = false), 3000);
          this.cards = data.data.datas;
        })
        .catch(() => {
          this.loading = false;
        });
  },
  methods: {
    getColor(val) {
      if (val === "ERROR") return "red";
      else if (val === "NO_ERROR") return "green";
      else return "green";
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
  },
};
</script>
